import { render } from "./AppSmallLoader.vue?vue&type=template&id=f2fdb4c2&scoped=true&ts=true"
import script from "./AppSmallLoader.vue?vue&type=script&lang=ts"
export * from "./AppSmallLoader.vue?vue&type=script&lang=ts"

import "./AppSmallLoader.vue?vue&type=style&index=0&id=f2fdb4c2&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2fdb4c2"]])

export default __exports__